import { render, staticRenderFns } from "./LayoutsContentView.vue?vue&type=template&id=98d01cf0&scoped=true"
import script from "./LayoutsContentView.vue?vue&type=script&lang=js"
export * from "./LayoutsContentView.vue?vue&type=script&lang=js"
import style0 from "./LayoutsContentView.vue?vue&type=style&index=0&id=98d01cf0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d01cf0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98d01cf0')) {
      api.createRecord('98d01cf0', component.options)
    } else {
      api.reload('98d01cf0', component.options)
    }
    module.hot.accept("./LayoutsContentView.vue?vue&type=template&id=98d01cf0&scoped=true", function () {
      api.rerender('98d01cf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/LayoutsContentView.vue"
export default component.exports